import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Termsconditions = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
         <>
      <Helmet>
        <title>Terms and Conditions - Yatri Interiors</title>
        <meta name="description" content="Crafting Interiors with Precision and Passion" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">
                    
                    <div className="col-lg-12 col-12">
                        <div className="about-right">
                            <div className="text">
                                <h2>Introduction</h2>
                                <p>Yatri Interiors is a professional interior design 
                                firm that offers residential,
                                 commercial, and modular design solutions. 
                                These Terms apply to all visitors, clients, 
                                and users of our website and services.
                                </p>
                                <h4>Services Offered</h4>
                                <p><b>Yatri Interiors provides</b></p>
                                
                               <ul>
                                    <li>Interior design consultation</li>
                                    <li>2D/3D visualization and planning</li>
                                    <li>Modular kitchen and furniture solutions</li>
                                    <li>Turnkey project execution</li>
                                </ul> 
                            <p>All services are subject to availability and mutual agreement between Yatri Interiors and the client.</p>
                            <h4>Appointments and Consultations</h4>
                            <ul>
                                <li>Clients must schedule appointments for in-person or virtual consultations.</li>
<li>Cancellations or rescheduling must be made at least 24 hours in advance.</li>
<li>Initial consultations may be free or chargeable, as per the current policy.</li>


                            </ul>
                                
                                <h4>Pricing and Payments</h4>
                               <ul>
                                <li>All prices are quoted in INR and are subject to change without prior notice.</li>
                                <li>Payment terms will be clearly defined in the service agreement.</li>
                                <li>Late payments may incur additional charges or interest as per agreed terms.</li>
                               </ul>
                                    
                               
                                   <h4>Project Timelines</h4>
                                   <ul>
                                    <li>Project timelines will be estimated at the start and may vary depending on design complexity, material availability, and client approvals.</li>
                                    <li>Delays due to unforeseen circumstances (e.g., natural disasters, supplier delays) are not the responsibility of Yatri Interiors.</li>
                                   </ul>
                                   <h4>Client Responsibilities</h4>
                                   <ul>
                                    <li>Clients must provide accurate information and timely approvals.</li>
                                    <li>Clients are responsible for securing necessary permissions (e.g., from housing societies or property owners).</li>
                                    <li>Unauthorized changes to project work without prior consent of Yatri Interiors are not permitted.</li>
                                   </ul>
                                   <h4>Intellectual Property</h4>
                                   <p>Our website may use cookies or similar technologies to:</p>
                                   <ul>
                                    <li>All design concepts, plans, and materials shared during the project remain the 
                                    intellectual property of Yatri Interiors unless otherwise stated in writing.</li>
                                    <li>Unauthorized use, reproduction, or sharing of our work is strictly prohibited.</li>
                                   
                                   </ul>
                            

                                   <h4>Cancellation and Refund Policy</h4>
                                   <ul>
                                    <li>Cancellation terms and refund eligibility will be outlined in the project agreement.</li>
                                    <li>Refunds, if applicable, will be processed within 15 working days after approval.</li>

                                   </ul>
                            <h4>Limitation of Liability</h4>
                            <p><b>Yatri Interiors shall not be liable for:</b></p>
                            <ul>
                                <li>
                                   Any indirect, incidental, or consequential damages.
                                </li>
                                <li>
                                   Losses caused due to third-party delays or actions.
                                </li>
                                <li>
                                   	Damages resulting from incorrect use or installation after project handover.
                                </li>
                            </ul>
•	
•

                      
                        <h4>Privacy Policy</h4>
                       <p>We respect your privacy and handle all personal data as outlined in our Privacy Policy. By using our services, you consent to such data collection and usage.</p>
                        <h4>Governing Law</h4>
                        <p>
                            These Terms shall be governed by and construed in accordance with the laws of the State of Karnataka, India. Any disputes will be subject to the jurisdiction of courts in Bangalore.
                        </p>
                        <h4>Modifications</h4>
                        <p>
                            Yatri Interiors reserves the right to modify these Terms at any time without prior notice. Continued use of our services constitutes acceptance of the updated Terms.
                        </p>
                        <h4>Contact Us</h4>
                        <p><b>For questions or concerns regarding these Terms, please contact us at: </b></p>
                        <p><b>Phone: 91 96632 22146  </b></p>
                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
        
    )
}

export default Termsconditions;